import { Box, Tab, Tabs, useMediaQuery } from "@mui/material";
import { useAtom } from 'jotai';
import { FC, useEffect, useRef, useState } from "react";
import { permissionsAtom } from '../../atoms/atom';
import AppBar from "../../components/app-bar/AppBar";
import Accounts from '../../components/configurations/accounts/Accounts';
import AdmissionScheduleConfigs from '../../components/configurations/admissionScheduleConfigs/AdmissionScheduleConfigs';
import ExternalCompanies from '../../components/configurations/external-companies/ExternalCompanies';
import Ignore2240Companies from '../../components/configurations/ignore-2240-companies/Ignore2240Companies';
import { useUtils } from '../../utils/utilFunctions';
import "./Configurations.scss";

const Configurations: FC = () => {
	const [aba, setAba] = useState<string>("USERS");
	const [permissions] = useAtom(permissionsAtom);
	const isMounted = useRef(true);
	const { verifyPermission } = useUtils();
	const isMobile = useMediaQuery('(max-width:768px)');

	const handleChangeAba = (event: React.SyntheticEvent, newValue: string) => {
		setAba(newValue);
	};

	useEffect(() => {
		return () => {
			isMounted.current = false;
		};
	}, []);

	useEffect(() => {
		if (!!permissions.length) {
			verifyPermission(permissions, 'SETTINGS');
		}
	}, []);

	return (
		<>
			<AppBar
				modulo="Configurações"
			/>
			<div className="configuracoes">
				<Tabs
					orientation={isMobile ? "horizontal" : "vertical"}
					variant="scrollable"
					value={aba}
					onChange={handleChangeAba}
					aria-label="Configurações"
					sx={{
						borderRight: isMobile ? 0 : 1,
						borderBottom: isMobile ? 1 : 0,
						borderColor: 'divider',
						minWidth: isMobile ? 'auto' : 240,
						width: isMobile ? '100%' : 'auto',
					}}
				>
					<Tab label="Usuários" value="USERS" />
					<Tab label="Empresas externas" value="COMPANIES" />
					<Tab label="Extração de eventos" value="EXECUTION-EVENTS" />
					<Tab label="Configuração de agendamentos" value="SCHEDULINGS" />
				</Tabs>
				<Box className="card">
					{aba === 'USERS' && <Accounts />}
					{aba === 'COMPANIES' && <ExternalCompanies />}
					{aba === 'EXECUTION-EVENTS' && <Ignore2240Companies />}
					{aba === 'SCHEDULINGS' && <AdmissionScheduleConfigs />}
				</Box>
			</div>
		</>
	);
}

export default Configurations